import { Alert, Snackbar } from "@mui/material";
import React from "react";
import { resetMessage } from "../../../store/slices/Notification";
import useCustomSnackBar from "./view/useCustomSnackBar";
import { capitalizeFirstLetter } from "../../helpers/format";
const CustomSnackBar = () => {
  const { notification, dispatch } = useCustomSnackBar();
  return (
    <>
      {notification.isOpen && (
        <Snackbar
          className="!z-[100000000000000000000000] fixed"
          open={true}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={() => {
              dispatch(resetMessage());
            }}
            severity={notification.type}
            variant="filled"
            sx={{ width: "100%" }}
            className=""
          >
            {capitalizeFirstLetter(notification.message)}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};

export default CustomSnackBar;
